import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";

import Player from "./Player";
import { cuteToast } from "../../UI/cute";
import UploadService from "../../../Services/FileUploadServices";


const useMultiAudio = (urls) => {
  const [sources] = useState(
    urls.map((url) => {
      const audio = new Audio(url.url);
      audio.preload = "none"; // Prevents preloading the audio
      return {
        url: url.url,
        audio,
      };
    })
  );

  const [players, setPlayers] = useState(
    urls.map((url) => {
      return {
        url: url.url,
        name: url.name,
        playing: false,
      };
    })
  );

  const toggle = (targetIndex) => () => {
    const newPlayers = [...players];
    const currentIndex = players.findIndex((p) => p.playing === true);
    if (currentIndex !== -1 && currentIndex !== targetIndex) {
      newPlayers[currentIndex].playing = false;
      newPlayers[targetIndex].playing = true;
    } else if (currentIndex !== -1) {
      newPlayers[targetIndex].playing = false;
    } else {
      newPlayers[targetIndex].playing = true;
    }
    setPlayers(newPlayers);
  };


  const stopAudio = () => {
    // console.log("Hello");
    sources.forEach((source, i) => {
      // console.log(players[i].playing);
      source.audio.pause();
    });
  };

  useEffect(() => {
    sources.forEach((source, i) => {
      //   console.log(players[i].playing);
      players[i].playing ? source.audio.play() : source.audio.pause();
    });
  }, [sources, players]);

  useEffect(() => {
    sources.forEach((source, i) => {
      source.audio.addEventListener("ended", () => {
        const newPlayers = [...players];
        newPlayers[i].playing = false;
        setPlayers(newPlayers);
      });
    });
    return () => {
      sources.forEach((source, i) => {
        source.audio.removeEventListener("ended", () => {
          const newPlayers = [...players];
          newPlayers[i].playing = false;
          setPlayers(newPlayers);
        });
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [players, toggle, stopAudio];
};
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

const Multiplayer = (props) => {
  const [selectedAudio, setSelectedAudio] = useState(null);
  const { audios } = props;
  const scrollRef = useRef(null);
  const [players, toggle, stopAudio] = useMultiAudio(audios);

  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [uploadUrl, setUploadUrl] = useState();
  const { sendRequest } = useHttp();
  const [ pageloader, setPageloader ] = useState(false);


  const handleSelectAudio = (url) => {
    setSelectedAudio(url);
    console.log("scroll", url);
    scrollToRef(scrollRef);
  };

  useEffect(() => {
    document.title = `Choose Audio`;
  });
  const token = useSelector((state) => state.auth.token);

  const inputFileRef = useRef(null);

  const { camp_id } = useParams();
  const history = useHistory();

  const responseHandle = (response) => {
    stopAudio();
    history.push("/render/" + camp_id);
    return false;
  };
  const handleSubmit = () => {
    // console.log(selectedAudio);

    // return false;
    if (selectedAudio) {
      sendRequest(
        {
          url: endPoints.setAudio,
          method: "POST",
          body: {
            camp_id,
            selectedAudio,
          },
        },
        responseHandle
      );
    } else {
      cuteToast({
        type: "error",
        message: "Please select the audio",
        timer: 5000,
        title: "",
      });
    }
  };

  // file upload

  const onDivClick = () => {
    inputFileRef.current.click();
  };

  const onFileChange = (e) => {
    let currentFiles = e.target.files;
    setProgress(0);
    setCurrentFile(currentFiles);

    if (checkMimeType(e) && checkFileSize(e)) {
      UploadService.uploadAudio(currentFiles[0], token, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
        .then((response) => {
          if (response.status === 200) {
            setUploadUrl(response.data.url);
            setSelectedAudio(response.data.url);
          }
          e.target.value = null;
        })
        .catch(() => {
          setProgress(0);
          setCurrentFile(undefined);
          setUploadUrl("");
          setSelectedAudio("");
        });

      // console.log(currentFileData);
    }
  };

  /* Check the 
        Audio type 
          and 
        check Audio File Size 
  */
  const checkMimeType = (event) => {
    //getting file object
    let files = event.target.files;
    //define message container
    let err = "";
    // list allow mime type
    const types = ["audio/mp3", "audio/mpeg", "audio/wav"];
    // loop access array

    //    console.log(files.length);
    if (types.every((type) => files[0].type !== type)) {
      err += files[0].type + " is not a supported format\n";
    }

    if (err !== "") {
      // if message not same old that mean has error
      event.target.value = null; // discard selected file
      cuteToast({
        type: "error",
        message: `${err}s`,
        timer: 5000,
        title: "Upload mp3/wav audio file",
      });
      return false;
    }
    return true;
  };

  const checkFileSize = (event) => {
    let files = event.target.files;
    let size = 40000000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      // console.log(files[x].size);
      if (files[x].size > size) {
        err += files[x].type + " is too large, please pick a smaller file\n";
      }
    }
    if (err !== "") {
      event.target.value = null;

      cuteToast({
        type: "error",
        message: `${err}s`,
        timer: 5000,
        title: "Upload mp3/wav audio file",
      });

      return false;
    }

    return true;
  };
  /* End Image type and check Image File Size */

  return (
    <>
    
      {pageloader && (
                <div className="position-absolute mini_loader">
                  <div className="loader2">
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              )}
      <div className="row">
        <div className="col-sm-8 audioScroll">
          <div className="row">
            {players.map((player, i) => (
              <Player
                key={i}
                player={player}
                selectedAudio={selectedAudio}
                handleSelectAudio={handleSelectAudio}
                setPageloader={setPageloader}
                toggle={toggle(i)}
                stopAudio={stopAudio}
              />
            ))}
          </div>
        </div>

        <div className="col-sm-4">
          <div className="bx_a ">
            
            <div
              className="upload_thmnl mb-4 align-items-center uploadDiv text-center"
              onClick={onDivClick}
            >
              <p className="text-primary">
                <u>Click to upload Audio/Voice-Over</u>
              </p>
              <p>
                <i>
                  <span>Audio (Only MP3 and WAV audio Allowed)</span>
                </i>
              </p>
              <br />
              <input
                name=""
                ref={inputFileRef}
                className="d-none"
                type="file"
                onChange={onFileChange}
              />
              {currentFile && (
                <div className="progress">
                  <div
                    className="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: progress + "%" }}
                  >
                    {progress}%
                  </div>
                </div>
              )}
            </div>

            {uploadUrl && <audio src={uploadUrl} controls />}
          </div>
        </div>
        <div ref={scrollRef}>
          <input
            name=""
            type="button"
            value="Save & Render Video"
            className="btn pull-right ms-3"
            onClick={handleSubmit}
          />
          <Link
            to={`/campaign/${camp_id}/edit`}
            className="btn bg-secondary border-secondary pull-right"
          >
            Edit Template
          </Link>
        </div>
      </div>
    </>
  );
};

export default Multiplayer;
